import { Location } from "../locationManagement/location";

export class OrderLocation extends Location{
    public OriginalId: number
}


// WEBPACK FOOTER //
// ./app/objects/management/order/orderLocation.ts